import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//*MUI
import { Box, Divider } from '@mui/material';

//*redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../../Redux Store/actions';

//*files
import cssClasses from './EventInventoryFloors.module.css';

import { AllotmentDiv, BlockDiv } from '../../../../Subcomponents/FloorComponent/FloorComponents';
import { getProjectByProjectName, getWingsIdByWingName } from '../../../../Services/SustenanceService';
import FloorsIcon from "../../../../Assets/Images/Common/noProjectFound.svg";
import { Fragment } from 'react';
import ClockIcon from '../../../Icons/ClockIcon';

import { setAlotEventGlobalUnitAvailable, getAlotEventGlobalLeadAvailable } from '../../../../Services/StoredSessionData';
import { groupBy, sortBy } from 'lodash';
import { getEventByEventName, getLaunchInventoryRelations, getUnitsOfLaunchesByWingId } from '../../../../Services/Event';
import { dismissLoader, presentLoader } from '../../../../Services/loader';
import { supabase } from '../../../../supabaseClient';
import Timer from '../../../../Subcomponents/CountDownTimer';

function EventInventoryFloors() {
  const navigate = useNavigate();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);
  const dispatch = useDispatch();
  const { eventID, projectId, wingName, launchId } = useParams();
  const [ProjectData, setProjectData] = useState([]);
  const [TotalUnits, setTotalUnits] = useState(0);
  const [TotalWings, setTotalWings] = useState(0);
  const [AllWings, setAllWings] = useState([]);
  const [EventName, setEventName] = useState("");
  const [Units, setUnits] = useState([]);
  const [NoUnitsFound, setNoUnitsFound] = useState(null);

  useEffect(() => {
    dispatch(action.activeMenu('eventinventory'));
    getProject();
  }, []);

  useEffect(() => {
    let updateUnitListener = supabase
      .from('Inventory')
      .on("UPDATE", (handleRecordUpdated) => {
        console.log(handleRecordUpdated);
      })
      .subscribe((status) => {
        console.log("status: ", status);
      });
    return () => {
      if (updateUnitListener) {
        supabase.removeSubscription(updateUnitListener);
        updateUnitListener = null;
      }
    }
  }, []);

  function getProject() {
    presentLoader()
    getEventByEventName(eventID).then((response99) => {
      console.log("Event-name", response99)
      setEventName(response99[0].title)
      getProjectByProjectName(projectId).then((resp) => {
        setProjectData(resp.data[0])
        if (resp.data[0]) {
          //*launchInventory
          getLaunchInventoryRelations(launchId).then((response33) => {
            console.log("launchInventory", response33)
            getWingsIdByWingName(wingName).then((response44) => {
              console.log("wing-Name", response44)
              setAllWings(response44.data)
            })
            setTotalWings(response33.data.length)
          }).catch((err) => {
            console.error("launchInventory", err)
          })
          getUnitsOfLaunchesByWingId(launchId, wingName).then((response66) => {
            console.log("getUnitsOfLaunchesByWingId", response66)
            if (response66.count > 0) {
              setNoUnitsFound(true)
            } else {
              setNoUnitsFound(false);
            }

            let _units = groupBy(response66.data, "unitId.floorNo");
            console.log("_units", _units)
            setUnits(_units)
            setTotalUnits(response66.count)
            dismissLoader()
          }).catch((err) => {
            console.error("getUnitsOfLaunchesByWingId", err)
          })
        }
      }).catch((err) => {
        console.error("Projects", err)
      })
    }).catch((err) => {
      console.error("Event-name", err)
    })

  }

  function goToUnit(unitNo) {
    if (unitNo) {
      console.log("unit----->", unitNo)
      navigate(`/home/Event/Details/${eventID}/Inventory/${launchId}/${projectId}/${wingName}/${unitNo}`)
    }
  }

  return (
    <Box className={cssClasses.Container}>
      <Box>
        <Box className={cssClasses.SubContainer} mb={2}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>
              {EventName}
            </Box>
            <Box>
              <Box className={cssClasses.Title}>
                Project :
                <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
                  {ProjectData?.projectName}
                </Box>{' '}
              </Box>

              <Box className={cssClasses.Title}>
                Location:
                <Box component={'span'} className={cssClasses.NumberTitle} ml={2}>
                  {ProjectData?.addressLine1} , {ProjectData?.addressLine2} , {ProjectData?.addressLine3}
                </Box>{' '}
              </Box>
            </Box>
          </Box>
        </Box>
        <Divider />
      </Box>
      <Divider />
      <Box className={cssClasses.FirstDiv}>


        <Box margin={'2rem 0'}>
          <Box className={cssClasses.Title}>
            Selected Wing:
            <Box
              component={'span'}
              className={cssClasses.NumberTitle}
              ml={2}
            >
              {/* {AllWings[0]?.wingName} */}
              {AllWings[0]?.displayName ? AllWings[0]?.displayName : AllWings[0]?.wingName}
            </Box>{' '}
          </Box>
        </Box>

        <Box margin={'2rem 0'}>
          <Box className={cssClasses.Title}>
            Total Units :
            <Box
              component={'span'}
              className={cssClasses.NumberTitle}
              ml={2}
            >
              {TotalUnits}
            </Box>{' '}
          </Box>
        </Box>
      </Box>

      <Box className={cssClasses.Floor}>
        <Box className={cssClasses.FloorTitle}>Floor </Box>
      </Box>
      {NoUnitsFound === false &&
        <Box mt={2}>
          <Box className={cssClasses.noDataMsg}>
            <Box className={cssClasses.emptyIcon}>
              <img src={FloorsIcon} alt="No Floor Available" />
            </Box>
            <Box className={cssClasses.emptyTitle}>No Floors were Found</Box>
          </Box>
        </Box>
      }

      {sortBy(Object.keys(Units), (fl) => { return isNaN(parseInt(fl.split(' ')[1])) ? 0 : parseInt(fl.split(' ')[1]) }).map((unitKey, unitKeyIndex) => (
        <Box mb={4} key={`${unitKey}_${unitKeyIndex}`}>

          <Box className={cssClasses.firstTitle}>{unitKey}</Box>
          <Divider />
          <Box className={cssClasses.BoxDiv} justifyContent={'center !important'}>
            <AllotmentDiv
              style={{ backgroundColor: '#D1FADF' }}
              content={'Available'}
              Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Available') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Available').length : "0"}
            />
            <AllotmentDiv
              style={{ backgroundColor: '#FEF0C7' }}
              content={'On Hold'}
              Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'On Hold') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'On Hold').length : "0"}
            />
            <AllotmentDiv
              style={{ backgroundColor: '#FFE6D5' }}
              content={'Preselected'}
              Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Preselected') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Preselected').length : "0"}
            />
            {/* // ! to hide these status as per client requirement => 28 March, 2023 */}
            {/* <AllotmentDiv
                style={{ backgroundColor: '#FEE4E2' }}
                // content={'Alloted'}
                content={'Payment Pending'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Payment Pending') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Payment Pending').length : "0"}
              />
              
              <AllotmentDiv
                style={{ backgroundColor: '#EFF8FF' }}
                content={'Kyc Pending'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Pending') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Pending').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#ECFDFF' }}
                content={'Kyc Done'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Done') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Kyc Done').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#FFFAEB' }}
                content={'SDR Payment Pending'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'SDR Payment Pending') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'SDR Payment Pending').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#F4EBFF' }}
                content={'Reserved'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Reserved') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Reserved').length : "0"}
              />
              <AllotmentDiv
                style={{ backgroundColor: '#F2F4F7' }}
                content={'Locked'}
                Quantity={Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Locked') ? Units[unitKey]?.filter(f => f.unitId.inventoryStatusId.status === 'Locked').length : "0"}
              /> */}
          </Box>


          <Divider />

          <Box className={cssClasses.MainDiv} >
            <Box className={cssClasses.flexRow}>
              <>
                {sortBy(Units[unitKey], "unitId.unitNo")?.map((unit, index) => (
                  <BlockDiv
                    key={`${unit}_${index}`}
                    clicked={() => {
                      if (unit.unitId.inventoryStatusId.status === 'Available' && getAlotEventGlobalLeadAvailable() === true) {
                        setAlotEventGlobalUnitAvailable(true);
                      } else {
                        setAlotEventGlobalUnitAvailable(false);
                      }
                      goToUnit(unit?.unitId.unitId);
                    }}
                    paired={unit.mergeId ? true : false}
                    pairedInfo={(unit?.unitId?.unitId === unit?.mergeId?.unit1Id) ? `Paired with ${unit?.mergeId?.unit2No}` : `Paired with ${unit?.mergeId?.unit1No}`}
                    // Name={unit.unitId.inventoryStatusId.status === 'On Hold' ? <p className={cssClasses.Manager}>SM:{unit?.unitId?.leadId?.userId?.name}</p> : ""}
                    // NameTitle={unit.unitId.inventoryStatusId.status === 'On Hold' ? unit.unitId?.leadId?.userId?.name : ""}
                    // CheckBox={unit.unitId.inventoryStatusId.status === 'On Hold' ? true : false}
                    style={unit.unitId.inventoryStatusId.status === 'Available' ? { color: '#027A48', backgroundColor: '#D1FADF' } : "" ||
                      unit.unitId.inventoryStatusId.status === 'On Hold' ? { color: '#B54708', backgroundColor: '#FEF0C7' } : "" ||
                        unit.unitId.inventoryStatusId.status === 'Payment Pending' ? { color: '#B42318', backgroundColor: '#FEE4E2' } : "" ||
                          unit.unitId.inventoryStatusId.status === 'Reserved' ? { color: '#6941C6', backgroundColor: '#F4EBFF' } : "" ||
                            unit.unitId.inventoryStatusId.status === 'Locked' ? { color: '#344054', backgroundColor: '#F2F4F7' } : "" ||
                              unit.unitId.inventoryStatusId.status === 'Preselected' ? { color: '#FF4405', backgroundColor: '#FFE6D5' } : "" ||
                                unit.unitId.inventoryStatusId.status === "Kyc Pending" ? { color: "#0E7090", backgroundColor: "#EFF8FF", } : "" ||
                                  unit.unitId.inventoryStatusId.status === "Kyc Done" ? { color: "#2E90FA", backgroundColor: "#D1E9FF", } : "" ||
                                    unit.unitId.inventoryStatusId.status === "SDR Payment Pending" ? { color: "#B54708", backgroundColor: "#FFFAEB", } : ""}
                    time={unit.unitId.inventoryStatusId.status === 'On Hold' &&
                      unit.unitId.unitHoldTime && <Fragment>
                        <Box className={cssClasses.Clock} mr={1}>
                          <Box component={'span'}><ClockIcon color='#B54708' fill={'none'} /></Box>
                          <Timer startFrom={unit.unitId.unitHoldTime} onComplete={() => { }}
                            timeFormatter={(time) => {
                              return (<span>{`0${Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / (1000 * 60 * 60))}`.slice(-2)}:{`0${Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / (1000 * 60)) % 60}`.slice(-2)}:{`0${Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / 1000) % 60}`.slice(-2)}</span>)
                            }}
                          />
                        </Box>
                      </Fragment>
                      // [unit.unitId.unitHoldTime ? (
                      //   <Fragment>
                      //     <Box className={cssClasses.Clock}>
                      //       <Box component={'span'}><ClockIcon color='#B54708' fill={'none'} /></Box>

                      //       <Timer startFrom={new Date(unit.unitId.unitHoldTime).getMilliseconds()} onComplete={() => { }}
                      //         timeFormatter={(time) => {
                      //           return (<span>{'00'}:{`0${Math.floor(time / 60)}`.slice(-2)}:{`0${time % 60}`.slice(-2)}</span>)
                      //         }}
                      //       />
                      //     </Box>
                      //   </Fragment>
                      // ) : (
                      //   <Fragment>
                      //     <Box className={cssClasses.Clock} mr={1}>
                      //       <Box component={'span'} mr={1.5}><ClockIcon color='#B54708' fill={'none'} /></Box>
                      //       <ReactStopwatch
                      //         hours={Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / (1000 * 60 * 60))}
                      //         minutes={Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / (1000 * 60)) % 60}
                      //         seconds={Math.floor(Math.abs(new Date().getTime() - new Date(unit.unitId.unitHoldTime).getTime()) / 1000) % 60}
                      //         // limit={ }
                      //         // onChange={({ hours, minutes, seconds }) => {
                      //         //   // do something
                      //         // }}
                      //         render={({ formatted, hours, minutes, seconds }) => {
                      //           return (
                      //             <div>{formatted}</div>
                      //           );
                      //         }}
                      //       />
                      //     </Box>
                      //   </Fragment>

                      // )] : ""
                    }
                    margin={unit.unitId.inventoryStatusId.status === 'On Hold' ? 0.5 : 3}
                    displayUnitType={
                      ProjectData?.displayInventoryType?.includes('Display Unit Type') && unit.unitId.displayUnitType !== null ?
                        unit.unitId.displayUnitType : ''}
                    Size={ProjectData?.displayInventoryType?.includes('Inventory Type') ?
                      unit.unitId.inventoryTypeId.type : ''}
                    flatNo={unit.unitId.unitNo}
                  // Price={unit.BSPTotal ?`₹ ${numDifferentiation(unit.BSPTotal)}` : ""}
                    UnitOf={unit.unitId.unitOf}
                  />
                ))}
              </>

            </Box>
          </Box>

          <Divider />
        </Box>
      ))}

    </Box>
  )
}

export default EventInventoryFloors